var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8F8F8C",
  fillRule: "evenodd",
  d: "m13.785 4.311-1.324 1.324 1.904 1.904 1.324-1.324a1.346 1.346 0 0 0-1.904-1.904m-.245 4.053L11.637 6.46l-5.905 5.904a4.05 4.05 0 0 0-1.016 1.706L4.2 15.8l1.73-.516a4.05 4.05 0 0 0 1.706-1.016zm-.58-4.878a2.513 2.513 0 1 1 3.554 3.554l-8.053 8.053a5.2 5.2 0 0 1-2.198 1.31l-2.763.823a.583.583 0 0 1-.726-.726l.823-2.763a5.2 5.2 0 0 1 1.31-2.198z",
  clipRule: "evenodd"
})));
export default SvgEdit;